<template>
  <div class="container">
    <base-frame
      :btns="btns"
      :breadcrumb="[
        {
          name: 'inspection',
          title: '验收单列表'
        },
        {
          name: 'inspectionInfo',
          title: 'UDI管理'
        }
      ]"
      @btn-click="onBtnClick"
    >
    <div slot="content">
      <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/>
      <lk-card title="商品详情">
        <div class="sum-wrap">
          <div class="title-amount">总商品数量</div>
          <div class="content-amount">{{inspectionGoodsNum}}</div>
          <div class="title-money">总金额（元）</div>
          <div class="content-money">&yen;{{inspectionAmount}}</div>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </lk-card>
      <lk-card v-if="[25, 7, 3].indexOf($store.state.storeInfo.id) >= 0" title="UDI编码录入" class="other-card">
        <lk-row class="reject-row" :gutter='16' style="margin-bottom:16px">
          <lk-col span="24" v-for="(item, index) in tableData" :key="index">
            <!-- :autosize='true' -->
            <span>{{ item.medicineInfoVoApprovedDrugNames }}</span>
            <lk-input v-model.trim="item.purchaseInspectionInfoUdiCodes"  type="textarea" placeholder="请输入UDI编码" :rows="5">
            </lk-input>
          </lk-col>
        </lk-row>
      </lk-card>
    </div>
    </base-frame>
  </div>
</template>

<script>

import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import ApprovalFlow from '../../components/ApprovalFlow';

export default {
  name: 'inspectionInfoUDI',
  components: {
    BaseFrame, Uploader, ApprovalFlow,
  },
  computed: {
    btns() {
      return [
        {
          name: 'submit',
          text: '提交',
          type: 'primary',
        },
        {
          name: 'cancel',
          text: '取消',
        },
      ];
    },
  },
  data() {
    return {
      inspectionGoodsNum: '',
      inspectionAmount: '',
      workNo: '',
      paymentType: ['普通', '寄售'],
      queryParams: {
        purchaseInspectionId: '',
      },
      columns: [
        {
          title: '行号',
          minWidth: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '批准文号',
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
        },
        {
          title: '规格',
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
          minWidth: 130,
        },
        {
          title: '商品名称',
          tooltip: true,
          key: 'medicineInfoVoGoodsName',
          minWidth: 142,
        },
        {
          title: '验收合格数',
          tooltip: true,
          key: 'purchaseInspectionInfoPassNum',
          minWidth: 94,
        },
        {
          title: '验收结果',
          tooltip: true,
          key: 'purchaseInspectionInfoResult',
          minWidth: 82,
        },
        {
          title: '实收数量',
          tooltip: true,
          key: 'purchaseInspectionInfoPassNum',
          minWidth: 82,
        },
        {
          title: '实际含税单价',
          tooltip: true,
          key: 'purchaseInspectionInfoPriceBeforeTax',
          minWidth: 106,
        },
        {
          title: '批号',
          key: 'purchaseInspectionInfoGoodsBatchNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '生产日期',
          key: 'purchaseInspectionInfoProdDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '有效日期',
          key: 'purchaseInspectionInfoExpiryDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '计划数量',
          tooltip: true,
          key: 'purchaseMedicineNum',
          minWidth: 82,
        },
        {
          title: '仓库',
          tooltip: true,
          key: 'purchaseInspectionInfoWareHouseName',
          minWidth: 94,
        },
        {
          title: '货位',
          tooltip: true,
          key: 'purchaseInspectionInfoLocationCode',
          minWidth: 94,
        },
        {
          title: '批次',
          tooltip: true,
          key: 'purchaseInspectionInfoGoodsBatchSeq',
          minWidth: 150,
        },
        {
          title: '拒收数量',
          tooltip: true,
          key: 'purchaseInspectionInfoRejectNum',
          minWidth: 82,
        },
        {
          title: '拒收原因',
          tooltip: true,
          key: 'purchaseInspectionInfoRejectReason',
          minWidth: 82,
        },
        {
          title: '起点温度',
          tooltip: true,
          key: 'purchaseReceiptInfoStartTemperature',
          minWidth: 82,
        },
        {
          title: '到店温度',
          tooltip: true,
          key: 'purchaseReceiptInfoEndTemperature',
          minWidth: 82,
        },
        {
          title: '储存条件',
          tooltip: true,
          key: 'medicineInfoVoStorageConditions',
          minWidth: 112,
        },
        {
          title: '剂型',
          tooltip: true,
          key: 'medicineInfoVoDosageFormString',
          minWidth: 116,
        },
        {
          title: '单位',
          tooltip: true,
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
          minWidth: 60,
        },
        {
          title: '产地',
          tooltip: true,
          key: 'purchaseMedicineCountryOfOrigin',
          minWidth: 142,
        },
        {
          title: '生产企业',
          tooltip: true,
          key: 'medicineInfoVoManufacturer',
          minWidth: 142,
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      localtion: [],
      type: ['审核中', '废弃', '完成'],
    };
  },
  methods: {
    onBtnClick(name) {
      if (name === 'cancel') {
        this.$router.push({ name: 'inspection' });
      } if (name === 'submit') {
        this.submitUDI();
      }
    },
    getData() {
      this.queryParams.purchaseInspectionId = this.$route.params.purchaseInspectionId;
      const queryParams = Object.assign({}, this.queryParams);
      // console.log(queryParams);
      purchase.inspectionInfo(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.inspectionAmount = res.data.data.inspectionAmount;
          this.inspectionGoodsNum = res.data.data.inspectionGoodsNum;

          res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseInspectionInfoExpiryDate = utils.formatTime(result.purchaseInspectionInfoExpiryDate, 'YYYY/MM/DD');
            result.purchaseInspectionInfoProdDate = utils.formatTime(result.purchaseInspectionInfoProdDate, 'YYYY/MM/DD');
            this.tableData.push(result);
          });
          if (res.data.data.purchaseInspection && res.data.data.purchaseInspection.workNo) {
            this.workNo = res.data.data.purchaseInspection.workNo;
          }
          res.data.data.purchaseRejectionInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    /**
     * 提交UDI
     *
     * @returns 无返回值
     */
    submitUDI() {
      const udiDataList = [];
      this.tableData.forEach((item) => {
        udiDataList.push({
          inspectionDetailId: item.purchaseInspectionInfoId,
          udiData: item.purchaseInspectionInfoUdiCodes,
        });
      });
      if (this.tableData.map(item => item.purchaseInspectionInfoUdiCodes).includes('')) {
        this.$Message.error('请填写UDI');
        return;
      }
      const temp = {
        inspectionId: this.$route.params.purchaseInspectionId,
        udiDataList,
      };
      console.log('数据-----', temp);
      purchase.submitUDI(temp).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.$router.push({ name: 'inspection' });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.reject-row{
  margin-bottom: 40px;
}
.steps-wrap{
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
